<template>
  <div class="home">
    <div class="structural-calculations">
      <div class="structural-calculations-content">
    <!-- HERO -->
    <section class="hero">
      <h1>Stop Losing Money on Rebar Production</h1>
      <p>
        Automate detailing, reduce waste, and send data directly to CNC machines —
        increase your margin on every ton.
      </p>
      <div class="cta">
        <button class="primary" @click="routerJump(1)">Start a Live Demo</button>
        <button class="secondary" @click="routerJump(2)">Send BIM Model</button>
      </div>
    </section>

    <!-- PAIN -->
    <section class="section">
      <h2>Every Project Is Costing You More Than You Think</h2>
      <ul>
        <li><b>√</b> Manual rebar detailing takes too long</li>
        <li><b>√</b> Errors in bar schedules cost money</li>
        <li><b>√</b> Repeated data entry in factory</li>
        <li><b>√</b> Material waste reduces profit</li>
      </ul>
      <p class="highlight">
        This is lost profit on every ton.
      </p >
    </section>

    <!-- SOLUTION -->
    <section class="section dark">
      <h2>DigiRebar Turns Your Workflow Into Profit</h2>
      <ul>
        <li><b>√</b> Auto generate bar bending schedules</li>
        <li><b>√</b> Optimize cutting to reduce waste</li>
        <li><b>√</b> Direct CNC machine output</li>
        <li><b>√</b> Standardized production workflow</li>
      </ul>
      <p class="highlight">
        Less labor. Less waste. More margin.
      </p >
    </section>

    <!-- BEFORE AFTER -->
    <section class="section">
      <h2>Before vs After DigiRebar</h2>
      <div class="grid">
        <div class="card">
          <h3>Before</h3>
          <ul>
            <li><b>√</b> Manual detailing</li>
            <li><b>√</b> Repeated input</li>
            <li><b>√</b> High error rate</li>
            <li><b>√</b> Material waste</li>
          </ul>
        </div>
        <div class="card">
          <h3>After</h3>
          <ul>
            <li><b>√</b> Automated schedules</li>
            <li><b>√</b> Direct CNC output</li>
            <li><b>√</b> Standardized data</li>
            <li><b>√</b> Optimized cutting</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- ROI -->
    <section class="section dark">
      <h2>What You Gain</h2>
      <div class="grid">
        <div class="card">💰 Increase profit per ton</div>
        <div class="card">⏱ Save 30–50% time</div>
        <div class="card">⚙️ Reduce errors</div>
        <div class="card">👷 Less reliance on labor</div>
      </div>
    </section>

    <!-- FREE HOOK -->
    <section class="section">
      <h2>Try It on Your Own Project</h2>
      <p>
        Send your revit model — we generate CNC-ready output for you.
      </p >
      <div class="video-wrap">
        <video class="demo-video" controls preload="metadata" playsinline>
          <source src="/media/video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <button class="primary big" @click="routerJump(2)">Watch Demo</button>
    </section>

    <!-- CTA FINAL -->
    <section class="hero bottom">
      <h2>Start Saving on Your Next Project</h2>
      <div class="cta">
        <button class="primary" @click="routerJump(1)">Start Demo Now</button>
        <button class="secondary" @click="routerJump(3)">Facebook Us</button>
      </div>
      <p>&nbsp;</p>
      <h3>
            Copyright Digirebar Limited HongKong
      </h3>
    </section>
      </div>
    </div>
    <!-- <HomeFooter /> -->
  </div>
</template>

<script>
import { ref, computed, onBeforeMount, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useMain } from "@/store/index";
import { finiteAppList, rebarList } from "@/utils/dataUtils";
import HomeTabs from "./HomeTabs.vue";
import HomePage1 from "@/views/home/HomePage1.vue";
import HomeBanner from "@/views/home/HomeBanner.vue";
import HomeFooter from "@/views/home/HomeFooter.vue";
export default {
  name: "Home",
  components: {
    HomeTabs,
    HomePage1,
    HomeBanner,
    HomeFooter
  },
  setup() {
    const useStoreMain = useMain();
    const router = useRouter();
    
    const pagination = {
      onChange: (page) => {
        console.log(page);
      },
      pageSize: 5,
    };
    const grid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 5, xxl: 5 };
    const grid1 = {
      gutter: 16,
      xs: 1,
      sm: 1,
      md: 1,
      lg: 2,
      xl: 2,
      xxl: 2,
      xxxl: 2,
    };
    /**导航栏点击 */
    const routerJump = (key) => {
      if(key==1){
        router.push({ name: "rebarMaterials" });
      }
      if(key==2){
        router.push({ name: "revit" });
      }
      if(key==3){
        window.open("https://www.facebook.com/digirebar?mibextid=wwXIfr&mibextid=wwXIfr");
      }
    };
    return {
      useStoreMain,
      pagination,
      grid,
      grid1,
      finiteAppList,
      rebarList,
      routerJump
    };
  },
};
</script>

<style lang="less" scoped>
.home {
  // background-color: #f7f7f7;
  background-color: rgb(243, 247, 251);
  
  height: calc(100vh - 64px);
  overflow-y: auto;
  

  .commont-box {
    width: 100%;
    background-color: #1890ff;
  }
  .commont-content {
    max-width: 1400px;
    margin: 0 auto;
  }

  .home-box {
    width: 100%;
    height: 100%;
    // background-image: url("@/assets/home1.jpg");
    background-size: cover;
    position: relative;
  }

  .structural-calculations {
    width: 100%;

    .structural-calculations-content {
      max-width: 100%;
      margin: 0 auto;
      // overflow: hidden;

      .double-line {
        word-break: break-all;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .structural-calculations-title {
        .px2vw(margin-right, 100);
        .px2vw(font-size, 26);
        font-weight: 900;
      }

/* HERO */
.hero {
  text-align: center;
  padding: 80px 20px;
  background: #111;
  color: white;
}

.hero h1 {
  font-size: 42px;
  margin-bottom: 20px;
  color: white;
}
.hero h2 {
  font-size: 30px;
  margin-bottom: 20px;
  color: white;
}
.hero h3 {
  color: white;
}
.hero p {
  font-size: 18px;
  max-width: 700px;
  margin: 0 auto 30px;
}


/* SECTION */
.section {
  padding: 60px 20px;
  text-align: center;
}

.section.dark {
  background: #d1d0d0d8;
}

.section h2 {
  font-size: 30px;
  margin-bottom: 20px;
  text-decoration: underline;
  text-decoration-color: #a0aba6e3; /* Vue 主题色 */
  text-underline-offset: 8px;
}

.section h3 {
  background: #111;
  color: white;
}

ul {
  list-style: none;
  padding: 0;
}

ul li {
  margin: 10px 0;
}
ul li b{
  color: green;
}
.highlight {
  margin-top: 20px;
  font-weight: bold;
  font-size: 18px;
}

/* GRID */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.card {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: white;
}

/* BUTTON */
.cta {
  margin-top: 20px;
}

button {
  margin: 10px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.primary {
  background: #ff3b3b;
  color: white;
}

.secondary {
  background: transparent;
  border: 1px solid white;
  color: white;
}

.big {
  font-size: 18px;
  padding: 15px 30px;
}

.video-wrap {
  margin: 24px auto 10px;
  max-width: 960px;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}

.demo-video {
  display: block;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  background: #000;
}

.bottom {
  background: #222;
}

  }
    }
      }
</style>
